import React from "react";

//const currentSlide = {number: 0}; 
//const AppContext = React.createContext(currentSlide.number);

const AppContext = React.createContext()
export default AppContext;